import {createReducer} from '@reduxjs/toolkit'
import {
    dTicketsClearFiltersAC,
    dTicketsEditItemAC, dTicketsMerchantDataLoaderAC,
    dTicketsSetDataAC,
    dTicketsSetDetailItemAC, dTicketsSetFiltersAC, dTicketsSetMerchantDataAC
} from 'model/dashboardTickets/dTicketsActionCreators';
import {logoutAC} from 'model/system/systemActionCreators';



// Type

export type typeMerchantData = {
    "active": boolean,
    "address": string,
    "comment": string,
    "dateCreated": string,
    "dateUpdated": string,
    "deleted": boolean,
    "email": string,
    "externalId": string,
    "externalSystemCode": string,
    "id": string,
    "inn": string,
    "name": string,
    "phoneNumber": string,
    "pinfl": string,
    "support": {
        "active": boolean,
        "address": string,
        "comment": string,
        "dateCreated": string,
        "dateUpdated": string,
        "deleted": boolean,
        "email": string,
        "id": string,
        "name": string,
        "phoneNumber": string,
    } | null,
    "turnover": number | null,
    "turnoverDate": string,
}


export type typeTicketResponse = {
    userCreated?: string,
    dateCreated?: string ,
    id?: string,
    text: string,
    viewedBySupport?: boolean,
    viewedByUser?: boolean,
}
export type typeAddTicketResponses = {
    id: string,
    responses: typeTicketResponse[],
}
export type IdTicketsStateDataItem = {
    responses?: typeTicketResponse[],
    name?: string,
    description?: string,
    id: string,
    status?: string,
    userCreated?: string,
    dateCreated?:string,
    dateUpdated?: string,
    viewedByCreator?: boolean,
    viewedBySupport?: boolean
}

export type typeTicketsFilters = {
    status?: string | null,
    description?: string | null,
    name?: string | null,
    dateCreated?: {
        from: string | null,
        to: string | null,
    } | null,
}

export type IdTicketsState =  {
    data: IdTicketsStateDataItem[],
    detailItem: IdTicketsStateDataItem | undefined
    filters: typeTicketsFilters,
    merchantData: typeMerchantData |  undefined
    merchantDataLoader : boolean
}


// Clean filter object
export const cleanFilterObject: typeTicketsFilters = {

    status: null,
    description: null,
    name: null,
    dateCreated: null
}

// Init state
export const initialState: IdTicketsState = {
    data: [],
    detailItem: undefined,
    filters: cleanFilterObject,
    merchantData: undefined,
    merchantDataLoader: false
}


// Reducer
export const DTicketsReducer = createReducer(initialState, builder => {
    builder

        // Reducer of set data
        .addCase(dTicketsSetDataAC, (state, action) => {
            state.data = action.payload.dataList
        })

        // Reducer of set detail item
        .addCase(dTicketsSetDetailItemAC, (state, action) => {
            state.detailItem = state.data.find((item) => item.id === action.payload)
        })

        // Reducer of set item in data
        .addCase(dTicketsEditItemAC, (state, action) => {
            state.data = state.data.map((item) => {
                if (item.id === action.payload.id) {
                    return action.payload
                } else {
                    return item
                }
            })
        })


        // Reducer of clear filtersForm
        .addCase(dTicketsClearFiltersAC, (state) => {
            state.filters = cleanFilterObject
        })

        // Reducer of set filtersForm
        .addCase(dTicketsSetFiltersAC, (state, action) => {
            state.filters = {...state.filters , ...action.payload }
        })

        // Reducer of set merchant data
        .addCase(dTicketsSetMerchantDataAC, (state, action) => {
            state.merchantData = action.payload
        })
        // Reducer of set merchant data loader
        .addCase(dTicketsMerchantDataLoaderAC, (state, action) => {
            state.merchantDataLoader = action.payload.loader
        })
        // Reducer of clear state
        .addCase(logoutAC, ( state ) => {
            state.data = initialState.data
            state.detailItem=initialState.detailItem
            state.filters = initialState.filters
            state.merchantData=initialState.merchantData

        })

})
